/* globals $ */
import '../../js/lib/jquery.min'
import '../../shared/js/src/preload'
import '../../shared/js/src/socials'
import updateContainer from './src/XP.js'

var pics = $('.pics')
for (var i = 0; i < pics.length; i++) {
  pics[i].onload = function () {
    init()
  }
  pics[i].src = pics[i].getAttribute('data-src')
}

function init () {
  updateContainer()// run when page first loads
  require(['../../js/lib/skrollr.min.js'], function (skrollr) {
    skrollr.init({
      edgeStrategy: 'set',
      easing: {
        WTF: Math.random,
        inverted: function (p) {
          return 1 - p
        }
      }
    })
  })
}
